import { render, staticRenderFns } from "./EmployerCardSettings.vue?vue&type=template&id=2b114c61"
import script from "./EmployerCardSettings.vue?vue&type=script&lang=ts"
export * from "./EmployerCardSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports